export function renderRelationshipLabelLabelTemplate({
  valueExpression
}: {
  valueExpression: string
}): string {
  return `const label = (() => {
        const toRelationshipLabel = (item: unknown): string | null => {
          if (item && typeof item === 'object') {
            const display =
              ('name' in item && item.name) ||
              ('title' in item && item.title) ||
              ('label' in item && item.label) ||
              ('email' in item && item.email) ||
              ('id' in item && item.id)
            return display === null || display === undefined || display === ''
              ? null
              : String(display)
          }
          return item === null || item === undefined ? null : String(item)
        }

        return Array.isArray(${valueExpression})
          ? ${valueExpression}.map(toRelationshipLabel).filter(Boolean).join(', ')
          : toRelationshipLabel(${valueExpression})
      })()`
}
